import { render, staticRenderFns } from "./Gift.vue?vue&type=template&id=259784d3"
import script from "./Gift.vue?vue&type=script&setup=true&lang=js"
export * from "./Gift.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports